module.exports = __webpack_public_path__ + "89f77f8095d9e187d2c5a01710c6583e.svg";